import mineBombThemeOne from '../pages/MineGame/images/mine-bomb.png'
import mineStarThemeOne from '../pages/MineGame/images/mine-star.png'
import mineMaskThemeOne from '../pages/MineGame/images/mine-mask-img.png'
import mineBombThemeTwo from '../pages/MineGame/images/mine-bomb-t2.png'
import mineStarThemeTwo from '../pages/MineGame/images/mine-star-t2.png'
import mineMaskThemeTwo from '../pages/MineGame/images/mine-mask-img-t2.png'

export const THEMES_CONFIG = [
  {
    themeId: 1,
    slug: 'theme-one',
    name: 'Theme 1',
    themeClassName: 'theme-one',
    ui: {
      plinko: {
        layout: 'classic'
      },
      blackjack: {
        layout: 'classic'
      }
    },
    mineAssets: {
      bomb: mineBombThemeOne,
      star: mineStarThemeOne,
      mask: mineMaskThemeOne
    }
    // cssVars: {
    //   '--primary': '#FFC692',
    //   '--primaryHover': '#540E9B',
    //   '--secondary': '#C83FEB',
    //   '--bgPrimary': '#220A06',
    //   '--bgSecondary': '#220A06',
    //   '--bgSecondary-09': 'rgba(34, 10, 6, 0.9)',
    //   '--tableRowBg': '#3D214F',
    //   '--tableRowBorder': '#4D2567',
    //   '--inputBorder': '#FFC692',
    //   '--brown-975': '#461E1B',
    //   '--brown-900': '#522614',
    //   '--brown-925': '#591528',
    //   '--orange-200': '#FFB823',
    //   '--orange-200-08': 'rgba(255, 185, 35, 0.8)',
    //   '--orange-200-10': 'rgba(255, 185, 35, 0.10)',
    //   '--orange-300': '#FFAA1D',
    //   '--orange-400': '#E58808',
    //   '--orange-800': '#D74D00',
    //   '--mineActiveTab': '#FFB823',
    //   '--mineInputFocus': '#FFC64F',
    //   '--fairnessBorder': '#461E1B',
    //   '--losswinBg': '#24140B',
    //   '--white-4': 'rgba(255, 255, 255, 0.4)',
    //   '--white-200': '#EFE6D3',
    //   '--footertext': '#FFE600',
    //   '--green-900': '#14CC69',
    //   '--minerrorInput': '#A92A4E',
    //   '--btnWhite': '#969592',
    //   '--mineBtnDisabled': '#ACACAC',
    //   '--dice-neutral-700': '#2D1106',
    //   '--dice-neutral-800': '#B34219',
    //   '--dice-primary-main': '#0F9C50',
    //   '--dice-green-main': '#0F9C50',
    //   '--dice-grey-100': '#F5CBBC',
    //   '--plinkoModalArrowBg': '#1F1107',
    //   '--plinkoFooterIcon': '#FFB823',
    //   '--plinkoFooterIconActive': '#FFE600',
    //   '--plinkoFooterIconInactive': '#B8860B',
    //   '--plinkoChatIconStroke': '#FFE600',
    //   '--plinkoSidebarGradient': 'linear-gradient(180deg, #4A1D16 0%, #220A06 100%)',
    //   '--plinko-label': '#FCEEE9',
    //   '--plinko-history-btn-0': '#411510',
    //   '--plinko-history-btn-1': '#5B1C17',
    //   '--plinko-history-btn-2': '#742719',
    //   '--plinko-history-btn-3': '#8D331A',
    //   '--plinko-history-btn-4': '#A94716',
    //   '--plinko-history-btn-5': '#C76318',
    //   '--plinko-history-btn-6': '#E27F20',
    //   '--plinko-history-btn-7': '#F49A2B',
    //   '--plinko-history-btn-8': '#FFB23F',
    //   '--plinko-history-btn-9': '#FFC86B',
    //   '--plinko-history-btn-100': '#D67A1F',
    //   '--plinko-history-btn-200': '#C55E1A',
    //   '--plinko-history-btn-300': '#B24E19',
    //   '--plinko-history-btn-400': '#9E4318',
    //   '--plinko-history-btn-500': '#873618',
    //   '--plinko-history-btn-600': '#742C18',
    //   '--plinko-history-btn-700': '#612418',
    //   '--plinko-history-btn-800': '#501B16',
    //   '--plinko-history-btn-900': '#3F1411',
    //   '--blackjack-score-0': '#980303',
    //   '--blackjack-score-1': '#298680',
    //   '--blackjack-border': '#59210D',
    //   '--blackjack-settings-bg': '#2D1106',
    //   '--blackjack-settings-hover': '#461E1B',
    //   '--blackjack-table-shadow': '0px 0px 40px 0px #583636',
    //   '--blackjack-footer-icon': '#FFB823'
    // }
  },
  {
    themeId: 2,
    slug: 'theme-two',
    name: 'Theme 2',
    themeClassName: 'theme-two',
    ui: {
      plinko: {
        layout: 'compact'
      },
      blackjack: {
        layout: 'compact'
      }
    },
    mineAssets: {
      bomb: mineBombThemeTwo,
      star: mineStarThemeTwo,
      mask: mineMaskThemeTwo
    }
    // cssVars: {
    //   '--primary': '#B882FF',
    //   '--primaryHover': '#E76EFF',
    //   '--secondary': '#EE39A1',
    //   '--bgPrimary': '#18173F',
    //   '--bgSecondary': '#14133D',
    //   '--bgSecondary-09': 'rgba(20, 19, 61, 0.9)',
    //   '--tableRowBg': '#3C1E64',
    //   '--tableRowBorder': '#3C1E64',
    //   '--inputBorder': '#B882FF',
    //   '--brown-975': '#3C1E64',
    //   '--brown-900': '#3C1E64',
    //   '--brown-925': '#F1E7FF',
    //   '--orange-200': '#E76EFF',
    //   '--orange-200-08': 'rgba(231, 110, 255, 0.8)',
    //   '--orange-200-10': 'rgba(231, 110, 255, 0.10)',
    //   '--orange-300': '#EE39A1',
    //   '--orange-400': '#F960B6',
    //   '--orange-800': '#EE39A1',
    //   '--mineActiveTab': '#EE39A1',
    //   '--mineInputFocus': '#E3CDFF',
    //   '--fairnessBorder': '#3C1E64',
    //   '--losswinBg': '#18173F',
    //   '--white-4': 'rgba(241, 231, 255, 0.6)',
    //   '--white-200': '#E3CDFF',
    //   '--footertext': '#E3CDFF',
    //   '--green-900': '#29A329',
    //   '--minerrorInput': '#F08A75',
    //   '--btnWhite': 'rgba(255, 255, 255, 0.3)',
    //   '--mineBtnDisabled': 'rgba(255, 255, 255, 0.5)',
    //   '--dice-neutral-700': '#18173F',
    //   '--dice-neutral-800': '#B882FF',
    //   '--dice-primary-main': '#EE39A1',
    //   '--dice-green-main': '#29A329',
    //   '--dice-grey-100': '#E3CDFF',
    //   '--plinkoModalArrowBg': '#18173F',
    //   '--plinkoFooterIcon': '#E3CDFF',
    //   '--plinkoFooterIconActive': '#EE39A1',
    //   '--plinkoFooterIconInactive': '#B882FF',
    //   '--plinkoChatIconStroke': '#E3CDFF',
    //   '--plinkoSidebarGradient': 'linear-gradient(180deg, #5C2797 0%, #281148 100%)',
    //   '--plinko-label': '#F1E7FF',
    //   '--plinko-history-btn-0': '#1A2743',
    //   '--plinko-history-btn-1': '#1F3153',
    //   '--plinko-history-btn-2': '#233D64',
    //   '--plinko-history-btn-3': '#274A75',
    //   '--plinko-history-btn-4': '#2B5887',
    //   '--plinko-history-btn-5': '#34679A',
    //   '--plinko-history-btn-6': '#3C77AE',
    //   '--plinko-history-btn-7': '#4E89C4',
    //   '--plinko-history-btn-8': '#6BA0E0',
    //   '--plinko-history-btn-9': '#8CB7F0',
    //   '--plinko-history-btn-100': '#59B7FF',
    //   '--plinko-history-btn-200': '#5B97FF',
    //   '--plinko-history-btn-300': '#7D6AFF',
    //   '--plinko-history-btn-400': '#A95FFF',
    //   '--plinko-history-btn-500': '#C44FD9',
    //   '--plinko-history-btn-600': '#D645C0',
    //   '--plinko-history-btn-700': '#E33F9B',
    //   '--plinko-history-btn-800': '#EE39A1',
    //   '--plinko-history-btn-900': '#F05C76',
    //   '--blackjack-score-0': '#B82F14',
    //   '--blackjack-score-1': '#29A329',
    //   '--blackjack-border': '#3C1E64',
    //   '--blackjack-settings-bg': '#18173F',
    //   '--blackjack-settings-hover': '#3C1E64',
    //   '--blackjack-table-shadow': 'none',
    //   '--blackjack-table-border': '#3C1E64',
    //   '--blackjack-table-bg': 'radial-gradient(ellipse at center, #3C1E64 0%, #2A1B52 50%, #18173F 100%)',
    //   '--blackjack-page-bg': '#14133D',
    //   '--blackjack-primary-btn-bg': '#EE39A1',
    //   '--blackjack-secondary-btn-bg': '#3C1E64',
    //   '--blackjack-secondary-btn-border': '#E76EFF',
    //   '--blackjack-footer-icon': '#E3CDFF',
    //   '--blackjack-accent-purple': '#E76EFF'
    // }
  }
]

export const DEFAULT_THEME = THEMES_CONFIG[1] || null
export const DEFAULT_THEME_SLUG = DEFAULT_THEME?.slug || 'theme-two'

const THEME_CSS_VAR_KEYS = [...new Set(
  THEMES_CONFIG.flatMap((theme) => Object.keys(theme.cssVars || {}))
)]

const THEME_CLASS_NAMES = THEMES_CONFIG.map((theme) => theme.themeClassName)

export const getThemeConfig = (themeValue) => {
  const normalizedThemeValue = String(themeValue || '').toLowerCase()

  return THEMES_CONFIG.find((theme) => {
    return theme.slug === themeValue ||
      theme.themeClassName === themeValue ||
      String(theme.themeId) === String(themeValue) ||
      theme.name.toLowerCase() === normalizedThemeValue
  }) || DEFAULT_THEME
}

export const getThemeSlug = (themeValue) => getThemeConfig(themeValue)?.slug || DEFAULT_THEME_SLUG

export const getThemeClassNames = () => [...THEME_CLASS_NAMES]

export const getDocumentThemeSlug = () => {
  if (typeof document === 'undefined') return null

  const activeClassName = THEME_CLASS_NAMES.find((themeClassName) => {
    return document.body?.classList?.contains(themeClassName)
  })

  return activeClassName ? getThemeSlug(activeClassName) : null
}

export const getThemeSlugFromDocument = () => {
  return getDocumentThemeSlug() || DEFAULT_THEME_SLUG
}

export const getActiveThemeSlug = () => {
  return getThemeSlugFromDocument()
}

export const getActiveThemeConfig = () => getThemeConfig(getActiveThemeSlug())

export const isThemeLayout = (themeValue, layout) => getThemeConfig(themeValue)?.ui?.plinko?.layout === layout

export const isBlackjackThemeLayout = (themeValue, layout) => getThemeConfig(themeValue)?.ui?.blackjack?.layout === layout

const clearThemeCssVars = () => {
  if (typeof document === 'undefined') return

  THEME_CSS_VAR_KEYS.forEach((key) => {
    document.documentElement.style.removeProperty(key)
  })
}

export const applyThemeToDocument = (themeValue) => {
  if (typeof document === 'undefined') return getThemeConfig(themeValue)

  const resolvedTheme = getThemeConfig(themeValue)
  clearThemeCssVars()

  document.body.classList.remove(...THEME_CLASS_NAMES)
  document.body.classList.add(resolvedTheme.themeClassName)

  Object.entries(resolvedTheme.cssVars || {}).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value)
  })

  return resolvedTheme
}
